module.exports = __webpack_public_path__ + "img/check_deny.ca906709.svg";